import React from 'react';

function Publications() {
  return (
    <>
    <div  className="breadcumb-wrapper"  style={{ backgroundImage: `url('/assets/img/hero/slider1.jpg')` }}>
      {/* <div className="breadcumb-wrapper" data-bg-src="/assets/img/hero/slider1.jpg"> */}
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Publications</h1>
          </div>
        </div>
      </div>
      <div className="container space">
        <h2>Monthly Magazines & Publications</h2>
      </div>
    </>
  );
}

export default Publications;

